/**
 * Offline and cache-related constants
 */

// Cache durations in milliseconds
export const CACHE_DURATION = {
  // Survey config cache - never expires (updated on every fetch)
  SURVEY_CONFIG: Infinity,

  // Cached survey table data - expires after 24 hours
  SURVEY_TABLE: 24 * 60 * 60 * 1000, // 24 hours
} as const;

// Cache limits
export const CACHE_LIMITS = {
  // Maximum number of surveys to cache for offline viewing
  SURVEY_TABLE_MAX_ITEMS: 10,
} as const;

// Offline survey sync statuses
export const OFFLINE_SURVEY_STATUS = {
  PENDING: 'pending', // Waiting to be synced
  SYNCING: 'syncing', // Currently being synced to server
  FAILED: 'failed', // Sync failed after retries
} as const;

export type OfflineSurveyStatus =
  (typeof OFFLINE_SURVEY_STATUS)[keyof typeof OFFLINE_SURVEY_STATUS];
